(function($) {
    function isNumeric(value) {
        return /^\d+$/.test(value);
    }

    function clearElement(target) {
        const el = $(target);

        $(el).empty();
        $(el).addClass('d-none');
    }

    function clearForm()
    {
        $('#minimum').val('');
        $('#maximum').val('');
        $('#generate').val('');
    }

    function displayItems(target, items, child = 'p', delay = 0)
    {
        setTimeout(() => {
            const el = $(target);

            el.removeClass('d-none');
    
            items.forEach(item => {
                if (child === 'p'){
                    $(el).append($('<p class="mb-0">').text(item));
                }else {
                    $(el)       
                        .append($('<div class="col-12 col-lg text-center mb-4">')
                        .html(`<div class="bg-dark text-white fs-4">${item}</div>`));
                }
            });    
        }, delay)
    }

    function validateNumericInRange(val, min, max) {
        return isNumeric(val) && val >= min && val <= max;
    }

    function validate() {
        const minimum = $('#minimum').val();
        const maximum = $('#maximum').val();
        const generate = $('#generate').val();

        const messages = [];
        
        if (!validateNumericInRange(minimum, 1, 5000)) {
            messages.push('Minimum number not numeric or outside of acceptable range (1 - 5000)');
        }

        if (!validateNumericInRange(maximum, 1, 5000)) {
            messages.push('Maximum number not numeric or outside of acceptable range (1 - 5000)');
        }

        if (!validateNumericInRange(generate, 1, 10)) {
            messages.push('Amount of numbers to generate not numeric or outside of acceptable range (1 - 10)');
        }

        if (parseInt(minimum) >= parseInt(maximum) || parseInt(maximum) <= parseInt(minimum)) {
            messages.push('Invalid number range ordering (minimum should be below maximum in value)');
        }

        if (parseInt(minimum) + parseInt(generate) > parseInt(maximum)) {
            messages.push('Unable to proceed, range too small for amount of numbers you wish to generate');
        }

        if (messages.length > 0) {
            displayItems('#errors', messages);
        }
        
        return messages;
    }

    function toggleLoader() {
        const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('loader'));
        modal.toggle();
    }

    $('.btn-generate').on('click touchstart', function(){
        const minimum = $('#minimum').val();
        const maximum = $('#maximum').val();
        const generate = $('#generate').val();

        clearElement('#errors');
        clearElement('#statuses');
        clearElement('#results');

        const messages = validate();

        if (messages.length > 0) {
            return;
        }

        toggleLoader();

        // Send Ajax with the values
        $.post('/generate', {minimum, maximum, generate})
            .done((data) => {
                if (data.errors === true) {
                    displayItems('#errors', data.messages, 'p', 2000);
                } else {
                    displayItems('#results', data.numbers, 'div', 2000);
                }
            })
            .fail(() => {
                displayItems('#errors', [
                    'Unable to generate numbers, a network error occurred'
                ], 'p', 2000);
            })
            .always(() => {
                setTimeout(() => {
                    toggleLoader();
                    clearForm();
                }, 2000);
            });

        // // const results = $('#results');

    });
    $('.btn-clear').on('click touchstart', function(){

        clearElement('#errors');
        clearElement('#statuses');
        clearElement('#results');

        toggleLoader();

        $.post('/clear', {})
            .done((data) => {
                displayItems(data.errors ? '#errors' : '#statuses', data.messages, 'p', 2000);
            })
            .fail(() => {
                displayItems('#errors', [
                    'Unable to clear database, a network error occurred'
                ], 'p', 2000);
            })
            .always(() => {
                setTimeout(() => {
                    toggleLoader();
                    clearForm();
                }, 2000);
            })
    });    
})(jQuery);
